import React from "react";
import "../styles/PrivacyPolicyStyle.css";

const JZCFaq = () => {
  return (
    <div className="jazz_discount_outer">
      <div className="container">
        <div className="discount_inner">
          <h2>Frequently Asked Questions (FAQs)</h2>
          <br />

          {/* Q1 */}
          <h3>1. What is Jobup?</h3>
          <p>
            Jobup is a job search and career platform that helps job seekers
            discover relevant opportunities based on their skills, interests,
            and preferences. It also supports employers in sourcing qualified
            candidates.
          </p>
          <br />

          {/* Q2 */}
          <h3>2. What can I do on Jobup?</h3>
          <p>
            Jobup lets you search and apply for jobs, track applications,
            receive personalised job recommendations and alerts, and connect
            employers with relevant candidates.
          </p>
          <br />

          {/* Q3 */}
          <h3>3. What subscription plans does Jobup offer?</h3>
          <p>
            Jobup offers weekly and monthly subscription plans, providing
            subscribers with access to premium content available on the
            platform.
          </p>
          <br />

          {/* Q4 */}
          <h3>4. What are the subscription prices?</h3>
          <p>Subscription Plans</p>
          <p>Weekly Plans (Exclusive of Tax)</p>
          <ul>
            <li>Basic — Rs. 50</li>
            <li>Value — Rs. 70</li>
            <li>Pro — Rs. 100</li>
            <li>Ultra — Rs. 125</li>
            <li>Premium — Rs. 150</li>
          </ul>
          <p>Monthly Plans (Exclusive of Tax)</p>
          <ul>
            <li>Elite Value — Rs. 360</li>
            <li>Elite Pro — Rs. 460</li>
            <li>Elite Premium — Rs. 560</li>
            <li>Signature — Rs. 660</li>
          </ul>
          <br />

          {/* Q5 */}
          <h3>5. Does the Jobup subscription automatically renew?</h3>
          <p>
            Yes. Subscription plans automatically renew at the end of each
            billing cycle unless the subscription is cancelled before the
            renewal date.
          </p>
          <br />

          {/* Q6 */}
          <h3>6. How can I cancel my Jobup subscription?</h3>
          <p>To unsubscribe from Jobup:</p>
          <ul>
            <li>Open the Menu on the Jobup platform.</li>
            <li>Go to your Profile.</li>
            <li>Select "Unsubscribe."</li>
            <li>Enter your registered mobile number.</li>
            <li>Click "Unsubscribe" to confirm.</li>
          </ul>
          <p>
            Once the cancellation is confirmed, your subscription will be
            permanently deactivated.
          </p>
          <br />

          {/* Q7 */}
          <h3>7. Are subscription payments refundable?</h3>
          <p>
            Subscription charges are generally non-refundable, including any
            unused portion of the subscription period, except where expressly
            stated otherwise or required by applicable law.
          </p>
          <br />

          {/* Q8 */}
          <h3>8. What happens if my subscription payment fails?</h3>
          <p>
            The Company or Billing Provider may attempt to recharge the
            subscription fee up to three times within 72 hours. If all attempts
            fail, access to premium content may be suspended until successful
            payment.
          </p>
          <br />

          {/* Q9 */}
          <h3>9. Can I download or copy content from Jobup?</h3>
          <p>
            Users are not permitted to download, copy, record, screenshot,
            reproduce, redistribute, or otherwise capture content available on
            the platform.
          </p>
          <br />

          {/* Q10 */}
          <h3>10. How can I contact Jobup Customer Support?</h3>
          <p>
            For any questions, technical issues, or assistance related to your
            Jobup subscription, please contact our customer support team:
          </p>
          <p>
            Email:{" "}
            <a href="mailto:support@econceptions.mobi">
              support@econceptions.mobi
            </a>
          </p>
          <br />
        </div>
      </div>
    </div>
  );
};

export default JZCFaq;
